var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientWaveA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 155.29,
    y1: -69.35,
    x2: 320.7,
    y2: 293.18,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 221)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe121"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480,.5H0V208.89l20,3.92,1.67.32c20.5,3.88,59.41,11.25,98.33,1.62,17.09-4.23,34.18-11.6,51.27-19,22.91-9.88,45.82-19.77,68.73-22.08,28.05-2.82,56.09,6.07,84.14,14.95,11.95,3.79,23.91,7.58,35.86,10.46,40,9.79,80,9.79,100,9.79h20V.5Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientWaveA);
export default __webpack_public_path__ + "static/media/gradient-wave-a.c6485da71389759a541d1f01f293efbd.svg";
export { ForwardRef as ReactComponent };